import React from 'react';
import { LastLocationProvider } from './LastLocationProvider';

export const AuthenticationRoutes = ({ children }) => {
    return (
        <LastLocationProvider>
            <div>{children}</div>
        </LastLocationProvider>
    );
};
